import React from 'react'

const API_BASE_URL = process.env.DOMAIN || 'http://localhost:8101'

export function getPopupGraphicType(fileName: string): 'image' | 'video' {
  const validImageExtensions = new Set(['.jpg', '.jpeg', '.png', '.gif', '.svg', '.webp'])
  const validVideoExtensions = new Set(['.mp4', '.webm'])

  const dot = fileName.lastIndexOf('.')
  const extension = dot !== -1 ? fileName.slice(dot).toLowerCase() : ''

  if (!validImageExtensions.has(extension) && !validVideoExtensions.has(extension)) {
    throw new Error('Nieprawidłowy format pliku')
  }

  return validImageExtensions.has(extension) ? 'image' : 'video'
}

type PopupMedia = {
  url: string
  type: 'image' | 'video'
  alt?: string
}

interface PopupProps {
  desktop: PopupMedia
  mobile: PopupMedia
}

const Media: React.FC<PopupMedia & { className: string }> = ({ url, type, alt = '', className }) =>
  type === 'image' ? (
    <img src={`${API_BASE_URL}/${url}`} alt={alt} className={`rounded ${className}`} />
  ) : (
    <video className={`rounded ${className}`} autoPlay loop muted playsInline>
      <source src={`${API_BASE_URL}/${url}`} type="video/mp4" />
    </video>
  )

export const PopupContent: React.FC<PopupProps> = ({ desktop, mobile }) => {
  return (
    <>
      <Media {...desktop} className="popup__desktop-image" />
      <Media {...mobile} className="popup__mobile-image" />
    </>
  )
}
